import { render, staticRenderFns } from "./Mine.vue?vue&type=template&id=b087ceaa"
import script from "./Mine.vue?vue&type=script&lang=js"
export * from "./Mine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports